import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-tax-master-list',
  templateUrl: './tax-master-list.component.html',
  styleUrls: ['./tax-master-list.component.css']
})
export class TaxMasterListComponent implements OnInit {

  taxMasterList: any = []
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  isLoading: any = false
  deleteTaxMasterId: any
  searchKey: any = ""
  cid: any;
  taxForm: any | FormGroup;
  updateTaxForm: any | FormGroup;
  addButton = false;
  formSubmitted = false;

  isEdit = false;
  singleTaxMasterData: any = []

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private generic_service: GenericService, private toastr: ToastrService,) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.taxForm = this.fb.group({
      name: [''],
      percentage: [''],
      amount: [''],
      description: ['']
    })

    this.updateTaxForm = this.fb.group({
      name: [''],
      percentage: [''],
      amount: [''],
      description: ['']
    })
    this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage);
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.recordsPerPage = event.rows;


    if (this.searchKey != "") {
      this.getAllTaxMasterByWildSearch(this.pageNumber, this.recordsPerPage)
    } else {
      this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage);
    }
  }

  getAllTaxMasterByWildSearch(pageNumber: any, recordsPerPage: any) {

    if (this.searchKey != "") {
      this.isLoading = true

      this.generic_service.getAllTaxMasterByWildSearch(this.searchKey, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          console.log(response);

          this.taxMasterList = response.response.taxMastersList
          this.totalRecords = response.response.totalRecords
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )
    } else {
      this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage)
    }

  }

  refreshSearch() {
    this.searchKey = ""
    this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage)
  }

  getAllTaxMasterWithPagination(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true
    this.generic_service.getAllTaxMasterWithPagination(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response);
        this.taxMasterList = response.response.taxMastersList
        this.totalRecords = response.response.totalRecords
        this.isLoading = false

      }
    )
  }

  // getAllTaxMaster(){
  //   this.isLoading = true
  //   this.generic_service.getAllTaxMaster().subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.taxMasterList = response.response
  //       this.count = response.response.length
  //       this.isLoading = false

  //     }
  //   )
  // }


  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
    document.getElementById("closeModalButton4")?.click()
  }

  selectTaxMaster(id: any) {
    this.deleteTaxMasterId = id
  }

  deleteTaxMaster() {
    this.generic_service.deleteTaxMaster(this.deleteTaxMasterId).subscribe(
      (res: any) => {
        console.log(res)
        this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage);
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  addTaxMaster() {
    this.addButton = true;
    this.formSubmitted = true;

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.taxForm.get('description').value,

      "name": this.taxForm.get('name').value,
      "percentage": Number(this.taxForm.get('percentage').value),
      "amount": Number(this.taxForm.get('amount').value),
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.addTaxMaster(body).subscribe(
      (response: any) => {
        console.log(response)
        this.taxForm.reset()
        this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage);

        this.cancelModel()
        this.toastr.success(response.message)
        this.addButton = false;
        this.formSubmitted = false;
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = false;
      }
    )
  }


  getTaxMasterById(productDisplayZoneById: any) {
    this.generic_service.getTaxMasterById(productDisplayZoneById).subscribe(
      (res: any) => {
        console.log(res)
        this.singleTaxMasterData = []
        this.updateTaxForm.setValue(
          {
            name: res.response.name,
            percentage: res.response.percentage,
            amount: res.response.amount,
            description: res.response.description,
          }
        );
        this.singleTaxMasterData.push(res.response);
        this.isEdit = true;
      },
      (err: any) => {
        console.log(err)
      }
    )
  }



  editTaxMaster() {
    let body = {
      "version": 0,
      "isActive": true,
      "description": this.updateTaxForm.get('description').value,
      "id": this.singleTaxMasterData[0].id,
      "taxMasterId": this.singleTaxMasterData[0].taxMasterId,
      "name": this.updateTaxForm.get('name').value,
      "percentage": Number(this.updateTaxForm.get('percentage').value),
      "amount": Number(this.updateTaxForm.get('amount').value),
      "cid": this.singleTaxMasterData[0].cid,
    }

    console.log(body)
    this.generic_service.editTaxMaster(body).subscribe(
      (response: any) => {
        this.isEdit = false;
        console.log(response)
        this.updateTaxForm.reset()
        this.cancelModel()
        this.getAllTaxMasterWithPagination(this.pageNumber, this.recordsPerPage);

        this.toastr.success(response.message)
        this.addButton = false;
        this.formSubmitted = false;
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = false;
      }
    )
  }

}



